/**
 * @description 开始重练
 */

import Api from '../../../../path';
import {fetchData} from '@umu/umu-fetch';

export interface IInput {
    practice_type: number; // 1 易错题，2 已收藏
    element_id?: number; // 练习的小节，不填时为重练全部,
    element_type?: number; // 1 每日一考题 0 普通考试题
}

export interface IOutput {
    practice_id: number;
}

export const startPractice = (data: IInput): Promise<IOutput> => {
    return fetchData(Api.QUESTION_COLLECTION_START_PRACTICE, data).then((res: IResponse<IOutput>) => {
        return res.data;
    });
};
